<article
  class="card-surface group flex flex-col transition duration-300 hover:border-brand-500/30"
>
  <div class="flex flex-1 flex-col gap-3 p-4 sm:p-5">
    <div class="flex items-start justify-between gap-3">
      <h3 class="text-lg font-semibold text-ink-100">{{ project.title }}</h3>
      <span
        class="mt-1 text-brand-400 transition group-hover:translate-x-0.5"
        aria-hidden="true"
      >
        →
      </span>
    </div>

    <p class="text-sm leading-relaxed text-ink-400">{{ project.description }}</p>

    <div class="flex flex-wrap gap-2">
      @for (tech of project.technologies; track tech) {
        <app-technology-badge [label]="tech" />
      }
    </div>

    <div class="mt-auto pt-1 text-sm font-medium">
      <a
        [href]="project.repositoryUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="text-brand-400 transition hover:text-brand-300"
      >
        {{ i18n.t().viewOnGithub }} ↗
      </a>
    </div>
  </div>
</article>
